import { FindyLogoLink } from '../../components/findy-logo-link.component';
import { NavExternalLinkItem, NavLinkItem } from '../../components/nav-item';
import { SignUpLink } from '../components/sign-up-link.component';
import styles from './public-desktop-content.component.module.scss';

type Props = {
  pathname: string;
};

export const PublicDesktopContent = ({ pathname }: Props) => {
  return (
    <div className={styles.wrapper}>
      <FindyLogoLink to="/" />
      <nav>
        <ul className={styles.menu}>
          <NavLinkItem
            href="/recommends"
            isCurrentPage={
              pathname === '/recommends' || pathname === '/companies'
            }
          >
            求人・企業検索
          </NavLinkItem>
          <NavLinkItem
            href="/pick-up"
            isCurrentPage={pathname.startsWith('/pick-up')}
          >
            メディア
          </NavLinkItem>
          <NavLinkItem
            href="/events"
            isCurrentPage={pathname.startsWith('/events')}
          >
            イベント
          </NavLinkItem>
          <NavExternalLinkItem
            href="https://freelance.findy-code.io/"
            rel="noopener"
            target="_blank"
          >
            Findy Freelance
          </NavExternalLinkItem>
          <NavExternalLinkItem
            href="https://findy-code.io/enterprise-service/"
            rel="noopener"
            target="_blank"
          >
            採用担当者の方はこちら
          </NavExternalLinkItem>
          <NavLinkItem
            href="/users/sign_in"
            isCurrentPage={pathname === '/users/sign_in'}
          >
            ログイン
          </NavLinkItem>
          <li
            style={{
              padding: '0 15px',
              display: 'flex',
              alignItems: 'center',
              marginBottom: '3px', // NavLinkItemのborderBottom分の調整
            }}
          >
            <SignUpLink />
          </li>
        </ul>
      </nav>
    </div>
  );
};
